import { persistReducer } from 'redux-persist'
import { Action } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  GetErpTableData: '[GetErpTableData] Action',
  SetErpData: '[SetErpData] Action',
  GetErpTranslateData: '[GetErpTranslateData] Action',
}

const initialErpState: IErpState = {
  erpColumnList: [],
  erpColumnValues: [],
  erpDefinitions: [],
  erpColumnNames: [],
  erpDataTypes: [],
  erpDe: [],
  erpEn: [],

  erpsOptions: []
}

export interface IErpState {
  erpColumnValues: [],
  erpColumnList: [],
  erpDefinitions: []
  erpColumnNames: [],
  erpDataTypes: [],
  erpDe: [],
  erpEn: [],

  erpsOptions: []
}

export const reducer = persistReducer(
  { storage, key: 'portal-Erp', whitelist:  [ ] },
  (state: IErpState = initialErpState, action: any) => {
    switch (action.type) {
      case actionTypes.GetErpTableData: {
        const erpColumnValues = JSON.parse(action.payload.data.erps);
        let headers = JSON.parse(action.payload.data.headers);
        let erpDefinitions = JSON.parse(action.payload.data.definitions);
        let erpColumnNames = action.payload.data.columnNames;
        let erpDataTypes = action.payload.data.dataTypes;
        let erpColumnList: any = [];
       
        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          erpColumnList.push(newElement[0]);
        });
        return { ...state, erpColumnList, erpColumnValues, erpDefinitions, erpDataTypes , erpColumnNames};
      }
    
      case actionTypes.SetErpData: {
        const erpColumnValues = action.payload.data;
        return { ...state, erpColumnValues };
      }

      case actionTypes.GetErpTranslateData: {
        const erpDe = JSON.parse(action.payload.data.de);
        const erpEn = JSON.parse(action.payload.data.en);
        return { ...state, erpDe, erpEn };
      }
      
      default:
        return state
    }
  }
)

export const actions = {
  getErpTableData: (data: any) => ({ type: actionTypes.GetErpTableData, payload: { data } }),
  getTranslateData: (data: any) => ({ type: actionTypes.GetErpTranslateData, payload: { data } }),
  setErpData: (data: any) => ({ type: actionTypes.SetErpData, payload: { data } }),
  store: () => ({ type: "def" }),
}

export function* saga() {

}
